module.exports = __webpack_public_path__ + "static/media/angularproject.6d763672.png";